import React, { useState, useEffect, useRef } from "react";

const History = ({ data }) => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Adjust the threshold as needed
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      });
    }, options);

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="scroll-section relative overflow-hidden"
    >
      <div className="flex flex-col lg:flex-row h-full items-center gap-16 ">
        <div className="flex-1  relative min-h-full flex items-center ">
          <div
            className={`absolute transition ease-in duration-700 w-full h-full inset-0 bg-black opacity-80  mix-blend-multiply ${
              visible ? "translate-y-[100%]" : "translate-y-[0%]"
            }`}
          ></div>
          <img src={data?.image} alt="" />
        </div>
        <div
          className={`flex-1 h-full transition ease-in duration-500 special-container flex flex-col justify-center ${
            visible
              ? "opactity-100 translate-x-[0%] scale-1"
              : "opacity-0 translate-x-[30%] scale-[0.6]"
          }`}
        >
          <h2 className="font-medium bebas text-white text-4xl lg:text-5xl mb-2 uppercase ">
            {data?.title}
          </h2>

          <div
            className="text-white text-xl lg:w-1/2 leading-[1.6]"
            dangerouslySetInnerHTML={{ __html: data?.text }}
          />
        </div>
      </div>
    </section>
  );
};

export default History;
